<template>
  <fin-data-loader :resolver="loadData">
    <template>
      <v-row class="ma-0" no-gutters>

        <!-- available Tools -->
        <v-col cols="8" md="4" order-md="2" order-sm="1" sm="5">
          <h4 v-if="$vuetify.breakpoint.smAndUp" class="mb-6">Verfügbare Tools</h4>
          <fin-tool-display v-for="(tool, index) in availableTools"
                            :key="'availableTool_' + index"
                            :id="tool.helpCenterId"
                            @click.native="toolClicked(tool)"
                            class="tool-link mb-4"
                            style="cursor: pointer"
                            :value="tool">
            <template #icon v-if="tool.priceModelFeatureId && !isPriceModelFeatureEnabled(tool.priceModelFeatureId)">
              <fin-subscription-lock color="fin-color-primary-dark"/>
            </template>
          </fin-tool-display>
        </v-col>

        <v-col v-if="$vuetify.breakpoint.xs" cols="4" md="8" sm="7">
          <v-img :max-width="80"
                 :src="require('@/assets/tools/tool-empty-state.svg')"
                 contain
                 style="float: right"/>
        </v-col>

        <!-- do not display any own tools in xs -->
        <v-col v-if="$vuetify.breakpoint.smAndUp" :class="$vuetify.breakpoint.sm ? 'pl-12' : ''" cols="12" md="8" order="1" order-sm="2"
               sm="7">

          <!-- the user does not have any own tools -->
          <v-row
            v-if="ownTools.shareScreeners.length + ownTools.etfScreeners.length + ownTools.shareRatings.length === 0"
            :style="$vuetify.breakpoint.sm ? '' : 'max-width: 80%'">
            <v-col cols="auto">
              <h4 class="mb-6">Deine Tools</h4>
              <p class="mb-6"
                 style="max-width: 340px;">
                Du hast noch keine eigenen Tools angelegt. Sobald sich das ändert, werden sie hier zu sehen sein.
              </p>
              <v-img :max-width="120"
                     :src="require('@/assets/tools/tool-empty-state.svg')"
                     contain
                     style="float: right"/>
            </v-col>
          </v-row>

          <!-- the user has own tools - display in sm -->
          <v-row v-else-if="$vuetify.breakpoint.sm">
            <v-col cols="12" offset-sm="5" sm="7">
              <h4>Deine Tools</h4>
            </v-col>

            <v-col offset-sm="1" sm="4">
              <v-img :max-width="120" :src="require('@/assets/tools/tool-toolbox.svg')" contain/>
            </v-col>

            <v-col
              v-if="ownTools.shareScreeners.length + ownTools.etfScreeners.length + ownTools.shareRatings.length > 0"
              cols="12" sm="7">
              <router-link v-for="(tool, index) in ownTools.shareScreeners"
                           :key="'shareScreener_' + index"
                           :to="tool.inactive ? {} : { name: 'shareScreenerExecute', params: { id: tool.id }}"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  show-type
                                  style="display: block;"/>
              </router-link>
              <router-link v-for="(tool, index) in ownTools.etfScreeners"
                           :key="'etfScreener_' + index"
                           :to="tool.inactive ? {} : { name: 'etfScreenerExecute', params: { id: tool.id }}"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  style="display: block;"
                                  show-type/>
              </router-link>
              <router-link v-for="(tool, index) in ownTools.shareRatings"
                           :key="'shareRating_' + index"
                           :to="tool.inactive ? {}: { name: 'finToolsRateSharesRatingExec', params: { srId: tool.id }}"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  show-type/>
              </router-link>
            </v-col>
          </v-row>

          <!-- the user has own tools - display in mdAndUp -->
          <v-row v-else
                 :style="$vuetify.breakpoint.lgAndUp ? 'max-width: 80%' : ''">
            <v-col cols="12" md="10" offset-md="2">
              <h4>Deine Tools</h4>
            </v-col>

            <v-col md="2">
              <v-img :max-width="120" :src="require('@/assets/tools/tool-toolbox.svg')" contain/>
            </v-col>

            <v-col v-if="ownTools.shareScreeners.length + ownTools.etfScreeners.length > 0" md="5">
              <router-link v-for="(tool, index) in ownTools.shareScreeners"
                           :key="'shareScreener_' + index"
                           :to="tool.inactive ? {} : { name: 'shareScreenerExecute', params: { id: tool.id }}"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  show-type
                                  style="display: block;"/>
              </router-link>
              <router-link v-for="(tool, index) in ownTools.etfScreeners"
                           :key="'etfScreener_' + index"
                           :to="tool.inactive ? {} : { name: 'etfScreenerExecute', params: { id: tool.id }}"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  style="display: block;"
                                  show-type/>
              </router-link>
            </v-col>

            <v-col v-if="ownTools.shareRatings.length > 0" md="5">
              <router-link v-for="(tool, index) in ownTools.shareRatings"
                           :key="'shareRating_' + index"
                           :to="tool.inactive ? {} : to(tool)"
                           v-style:opacity="tool.inactive ? 0.5 : 1"
                           class="tool-link">
                <fin-tool-display :value="tool"
                                  class="mb-4"
                                  hide-icon
                                  show-type/>
              </router-link>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </template>
  </fin-data-loader>
</template>


<script>
import FinToolDisplay from "@/components/common/ToolDisplay"
import {listDashboardShareScreeners, listDashboardEtfScreeners, listMyHubToolShareRatings} from "@/js/finQueries"
import {API, graphqlOperation} from '@/plugins/finAmplifyModules'
import {mapGetters} from "vuex"
import FinDataLoader from "@/components/common/DataLoader"
import AmplitudePush from "@/mixins/AmplitudePush"
import {EventBus} from "@/plugins/fincraft"
import {PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import PriceModel from "@/mixins/PriceModel"
import toolMocks from '@/mocks/Tools'
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'fin-tools-wrapper',
  components: {FinSubscriptionLock, FinDataLoader, FinToolDisplay},
  mixins: [AmplitudePush, PriceModel],
  data() {
    return {
      /** Tools sorted in the same way as they will be displayed */
      ownTools: {
        shareScreeners: [],
        etfScreeners: [],
        shareRatings: []
      }
    }
  },
  computed: {
    availableTools() {
      return toolMocks.items.filter(i => {
        return !i.hide && !i.finhubHide && (!i.hideIfFeatureEnabled || (i.hideIfFeatureEnabled && !this.isPriceModelFeatureEnabled(i.priceModelFeatureId)))
      })
    },
    ...mapGetters('auth', ['userId'])
  },
  methods: {
    to(tool) {
      if (!tool.share.active || !tool.share.covered || tool.share.delisted) {
        return {name: 'finToolsRateShares'}
      } else {
        return {name: 'finToolsRateSharesRatingExec', params: {srId: tool.id}}
      }
    },
    loadData() {
      // we do not display the own tools any more in xs, but if the user turns its device he will need the data
      if (this.userId) {
        API.graphql(graphqlOperation(listDashboardShareScreeners, {
          limit: 2
        })).then(result => {
          const res = result.data.listOwnerScreenerConfiguration.items
          // hard-code tool type + link as currently there is only share screener
          // TODO: remove if the tool type + link are dynamically sent via API
          this.ownTools.shareScreeners = [...res].map((t) => ({
            ...t,
            type: 'AKTIEN-SCREENER',
          }))
        }).catch(error => {
          console.error("error loading owner share screener tools", error)
        })

        API.graphql(graphqlOperation(listDashboardEtfScreeners, {
          limit: 2
        })).then(result => {
          const res = result.data.listOwnerEtfScreenerConfiguration.items
          this.ownTools.etfScreeners = [...res].map((t) => ({
            ...t,
            type: 'ETF-SCREENER',
          }))
        }).catch(error => {
          console.error("error loading owner etf screener tools", error)
        })

        API.graphql(graphqlOperation(listMyHubToolShareRatings, {
          filter: {owner: {eq: this.userId}},
          sort: {direction: 'desc', field: 'ratedAt'},
          limit: 2
        })).then(result => {
          const res = result.data.listOwnerShareRating.items
          this.ownTools.shareRatings = [...res].map((t) => ({
            ...t,
            type: 'AKTIE BEWERTEN',
          }))
        }).catch(error => {
          console.error("error loading owner BdA tools", error)
        })
      }
    },
    toolClicked(tool) {
      if (tool.priceModelFeatureId && !this.isPriceModelFeatureEnabled(tool.priceModelFeatureId)) {
        EventBus.$emit('showSubscriptionPopup', tool.priceModelFeatureId, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      } else {
        this.$router.push(tool.to)
        if (tool.tracking) {
          this.pushToAmplitude({
            'event': tool.tracking.event('finhub_tools'),
            'step': tool.tracking.step,
            'placement': 'finhub_tools',
            'vue_breakpoint': this.$vuetify.breakpoint.name
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

p {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

a.tool-link {
  text-decoration: none;
}

a.tool-link:hover {
  text-decoration: none;
}
</style>
